import React, { useEffect } from 'react';
import { trackEvent } from '../firebase/config.js';
import { trackPixels } from '../analytics/pixels.js';

const CheckoutCancel = () => {
    useEffect(() => {
        try { trackEvent('checkout_cancel'); } catch (_) {}
        try { trackPixels('PageView', { page: 'checkout_cancel' }); } catch (_) {}
    }, []);
    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #111827 0%, #0f172a 100%)',
            display: 'flex',
            flexDirection: 'column'
        }}>
            <header style={{
                width: '100%',
                padding: '16px 0',
                borderBottom: '1px solid rgba(255,255,255,0.08)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <a href="/app/home" style={{
                    textDecoration: 'none',
                    fontWeight: 700,
                    fontSize: 18,
                    backgroundImage: 'linear-gradient(135deg,#14B8A6,#10B981)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent'
                }}>FlashFonic</a>
            </header>
            <main style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '24px'
            }}>
                <div style={{
                    width: '100%',
                    maxWidth: 560,
                    background: 'rgba(31,41,55,0.9)',
                    border: '1px solid rgba(255,255,255,0.08)',
                    borderRadius: 16,
                    padding: 24,
                    color: 'white',
                    textAlign: 'center',
                    boxShadow: '0 20px 40px rgba(0,0,0,0.4)'
                }}>
                    <h2 style={{
                        marginTop: 0,
                        marginBottom: 8,
                        backgroundImage: 'linear-gradient(135deg,#3B82F6,#14B8A6,#10B981)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent'
                    }}>Checkout canceled</h2>
                    <p style={{ color: 'rgba(255,255,255,0.8)' }}>No worries. You can try again anytime.</p>
                    <div style={{ marginTop: 16 }}>
                        <a href="/app/home" style={{
                            display: 'inline-block',
                            width: '100%',
                            maxWidth: 320,
                            padding: '12px 16px',
                            background: 'linear-gradient(135deg,#14B8A6,#10B981)',
                            borderRadius: 12,
                            color: 'white',
                            textDecoration: 'none',
                            fontWeight: 600
                        }}>Back to app</a>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default CheckoutCancel;


